import useViewportSize from './useViewportSize';
export var ViewType;
(function (ViewType) {
    ViewType[ViewType["mobile"] = 0] = "mobile";
    ViewType[ViewType["pad"] = 1] = "pad";
    ViewType[ViewType["desktop"] = 2] = "desktop";
})(ViewType || (ViewType = {}));
export const PAD_START = 768;
export const DESKTOP_START = 1024;
const useViewType = () => {
    const [viewportWidth] = useViewportSize();
    if (viewportWidth >= DESKTOP_START) {
        return ViewType.desktop;
    }
    if (viewportWidth >= PAD_START && viewportWidth < DESKTOP_START) {
        return ViewType.pad;
    }
    return ViewType.mobile;
};
export const useIsDesktop = () => {
    const viewType = useViewType();
    return viewType === ViewType.desktop;
};
export default useViewType;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlVmlld1R5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9AZWlrYS9ob29rcy9zcmMvdXNlVmlld1R5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxlQUFlLE1BQU0sbUJBQW1CLENBQUM7QUFFaEQsTUFBTSxDQUFOLElBQVksUUFJWDtBQUpELFdBQVksUUFBUTtJQUNoQiwyQ0FBTSxDQUFBO0lBQ04scUNBQUcsQ0FBQTtJQUNILDZDQUFPLENBQUE7QUFDWCxDQUFDLEVBSlcsUUFBUSxLQUFSLFFBQVEsUUFJbkI7QUFFRCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsR0FBRyxDQUFDO0FBQzdCLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxJQUFJLENBQUM7QUFFbEMsTUFBTSxXQUFXLEdBQUcsR0FBYSxFQUFFO0lBQy9CLE1BQU0sQ0FBQyxhQUFhLENBQUMsR0FBRyxlQUFlLEVBQUUsQ0FBQztJQUUxQyxJQUFJLGFBQWEsSUFBSSxhQUFhLEVBQUUsQ0FBQztRQUNqQyxPQUFPLFFBQVEsQ0FBQyxPQUFPLENBQUM7SUFDNUIsQ0FBQztJQUVELElBQUksYUFBYSxJQUFJLFNBQVMsSUFBSSxhQUFhLEdBQUcsYUFBYSxFQUFFLENBQUM7UUFDOUQsT0FBTyxRQUFRLENBQUMsR0FBRyxDQUFDO0lBQ3hCLENBQUM7SUFFRCxPQUFPLFFBQVEsQ0FBQyxNQUFNLENBQUM7QUFDM0IsQ0FBQyxDQUFDO0FBRUYsTUFBTSxDQUFDLE1BQU0sWUFBWSxHQUFHLEdBQVksRUFBRTtJQUN0QyxNQUFNLFFBQVEsR0FBRyxXQUFXLEVBQUUsQ0FBQztJQUMvQixPQUFPLFFBQVEsS0FBSyxRQUFRLENBQUMsT0FBTyxDQUFDO0FBQ3pDLENBQUMsQ0FBQztBQUVGLGVBQWUsV0FBVyxDQUFDIn0=